module.exports = __webpack_public_path__ + "linea-software-10.14427f95ed19faa7678d.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/linea-icons/fonts/linea-software-10.svg
// module id = ../../../../../src/assets/scss/icons/linea-icons/fonts/linea-software-10.svg
// module chunks = styles